import {
  Autocomplete,
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { ChangeEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { EezyCompany, TYPE_EXTERNAL, TYPE_INTERNAL } from "../invoiceAPI";

interface Props {
  eezyCompany: EezyCompany | undefined;
  invoiceType: string;
  eezyCompanyOptions: EezyCompany[];
  setEezyCompany: (company: EezyCompany) => void;
  setInvoiceType: (type: string) => void;
}

export const InvoiceDialogBasicInfo = ({
  eezyCompany: eC,
  invoiceType,
  eezyCompanyOptions,
  setEezyCompany: setEC,
  setInvoiceType,
}: Props) => {
  const { t } = useTranslation("invoices");

  const [eezyCompany, setEezyCompany] = useState<EezyCompany | undefined>(eC);
  const [type, setType] = useState(invoiceType);

  const selectType = (event: ChangeEvent<HTMLInputElement>) => {
    const value = (event.target as HTMLInputElement).value;
    setType(value);
    setInvoiceType(value);
  };

  const selectEezyCompany = (event: any, newValue: any) => {
    setEezyCompany(newValue);
    setEC(newValue);
  };

  return (
    <Box>
      <Box>
        <Typography sx={{ marginBottom: "15px" }}>
          {t("selectEezyCompany")}
        </Typography>
        <FormControl fullWidth>
          <Autocomplete
            value={eezyCompany}
            size="small"
            getOptionLabel={(option) => option.name}
            onChange={selectEezyCompany}
            options={eezyCompanyOptions}
            renderInput={(params: any) => <TextField {...params} />}
          />
        </FormControl>
      </Box>
      <Box>
        <FormControl fullWidth>
          <FormLabel>
            <Typography
              variant="header"
              sx={{
                textTransform: "uppercase",
                fontWeight: 700,
                marginTop: "35px",
                marginBottom: "15px",
              }}
            >
              {t("invoiceType")}
            </Typography>
          </FormLabel>
          <RadioGroup value={type} onChange={selectType}>
            <FormControlLabel
              value={TYPE_EXTERNAL}
              control={<Radio />}
              label={t(TYPE_EXTERNAL)}
            />
            <FormControlLabel
              value={TYPE_INTERNAL}
              control={<Radio />}
              label={t(TYPE_INTERNAL)}
            />
          </RadioGroup>
        </FormControl>
      </Box>
    </Box>
  );
};
